import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserProfileDetails,
  handleScrollToBottom,
  handleShowAIScreen,
} from "../../../appStore/actions/AppState/action";
import {
  fetchOldMessageFromApi,
  handleDeleteGroupMessage,
  handleFetchOldMessage,
  handleGetStarMessages,
  handleStarMessage,
} from "../../../appStore/actions/ArkchatGroup/action";
import { groupMsgDeleteType } from "../../../utils/constant";
import StarMessageView from "./StarMessageView";
import GroupMessageView from "./GroupMessageView";
import TempMessageView from "./TempMessageView";
import AiFloat from "../../../assets/images/chats/aifloaticon.svg";
import DirectMessageView from "./DirectMessageView";
import session, { findUser, setProfileData } from "../../../utils/helper";
import ProfileDetailModal from "../../../common/ProfileDetailModal";
import EmptyMsg from "./EmptyMsg";
import { useTranslation } from "react-i18next";
import { colorSchemes, FloatBtnStyle, FloatImgStyle, fontSizeSchemes } from "../../../assets/commonFunction";
import LableToolTip from "../../../common/LableToolTip";
import useAppSelectors from "../../../customHooks/useAppSelectors";

export const classes = {
  chatUserprofile: {
    bgcolor: "#E3E1E1",
    width: "30px",
    height: "30px",
    display: "flex",
    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",
    objectFit: "cover",
    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },
  highlight: {
    bgcolor: "blue",
  },
  chatUserprofile2: {
    bgcolor: "#E3E1E1",
    width: "25px",
    height: "25px",
    display: "flex",
    flex: "none",

    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",
    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },
  userlink: {
    color: "#2C86FF",
    lineHeight: "15px",
    fontSize: "13px",
    fontWeight: "450",
    cursor: "pointer",
  },
  duetime: {
    color: "#000",
    opacity: "80%",
    fontSize: "13px",
    paddingTop: "1px",
  },
  userlink2: {
    color: "#2C86FF",
    display: "inline-block",
    fontSize: "0.75rem",
  },
  userInfo: {
    marginTop: "-5px !important",
    width: "100%",
  },
  tick: {
    objectFit: "cover",
    maxWidth: "17px",
    maxHeight: "6px",
    img: {
      width: "100%",
    },
  },
  pendingT: {
    borderRadius: "4px",
    padding: "5px 10px",
    height: "30px",
    textAlign: "center",
    maxHeight: "1.5rem",
    justifyContent: "center",
  },

  txt: {
    marginLeft: "2px !important;",
    color: colorSchemes.themeRedColor,
    fontSize: fontSizeSchemes.font12,
    fontWeight: 500,
  },
  chatRep: {
    background: "#efefef",
    padding: "4px 10px",
    borderRadius: "3px",
    margin: "10px 0 8px",
    // cursor:"pointer"
  },
};

const MessageList = ({
  setMediaFilesOpen,
  setReplyParentMsg,
  handlegetThreadMessages,
  handleBacktoMessage,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  setisTopicOpen,
  handleReadStatusDrawer,
  handleSendTempMsg,
  handleClickTaskUpdate,
  progress,
  handleAddgroupMember,
  isSearchGroupInfoOpen,
  handleSearch,
  setIsSearchGroupInfoOpen,
  isPrivateChatOn,
  highlightText,
  searchInputValue,
  onPreviewFile,
}) => {

  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData, selectedGroup, tempMsgList, showStarMessage, selectedTopic, selectedSubtopic, groupmemberdetails, groupRecipientDetails, starMsgData, messageList } = useAppSelectors();
  const isScrollToBottom = useSelector((state) => state?.appStateData?.isScrollToBottom);
  const isThreadScreen = session.get("isThreadScreen");


  const chatContainerRef = useRef(null);
  const menuRef = useRef(null);
  const threeDotRef = useRef(null);
  const isLoadingOldMsgRef = useRef(false);
  const hasReachedEndRef = useRef(false);
  // Snapshot of scrollHeight taken just before a prepend dispatch.
  // useLayoutEffect reads this to calculate the exact delta and correct
  // scrollTop in the same frame as the DOM update — no visible jump.
  const prevScrollHeightRef = useRef(null);
  const [isMoreMenuOpen, setMoreMenu] = useState(false);
  const [isDMMoreMenuOpen, setDMMoreMenuOpen] = useState(null);
  const [isDeleteGroupMsgOpen, setDeleteGroupMsgOpen] = useState(false);
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [isDeleteGroupMsgOpenIndicatorId, setDeleteGroupMsgOpenIndicatorId] =
    useState(null);
  const [deleteGrpMsgType, setDeleteGrpMsgType] = useState("");
  const dispatch = useDispatch();
  const [isScrollingToTop, setIsScrollingToTop] = useState(false);
  const [localStarMsgData, setLocalStarMsgData] = useState([]);
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const [startTaskOpen, setStartTaskOpen] = useState(null);
  const [isShowGroupName, setIsShowGroupName] = useState(false);

  ////////
  const scrollToBottom = () => {
    if (chatContainerRef?.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMoreMenu(null);
    }
  };
  const toggleItemMenu = (item) => {
    if (isMoreMenuOpen?.timetoken === item?.timetoken) {
      setMoreMenu(null);
    } else {
      setMoreMenu(item);
    }
  };

  const handleStartTask = (item) => {
    if (startTaskOpen?.timetoken === item?.timetoken) {
      setStartTaskOpen(null);
    } else {
      setStartTaskOpen(item);
    }
  };

  const handleDeleteGrpMsg = (msgData) => {
    if (deleteGrpMsgType === groupMsgDeleteType?.me) {
      dispatch(handleDeleteGroupMessage(msgData, false)).then((res) => { });
      setDeleteGrpMsgType("");
      setDeleteGroupMsgOpen(false);
      setDeleteGroupMsgOpenIndicatorId(null);
    } else if (deleteGrpMsgType === groupMsgDeleteType?.all) {
      dispatch(handleDeleteGroupMessage(msgData, true)).then((res) => { });
      setDeleteGrpMsgType("");
      setDeleteGroupMsgOpen(false);
      setDeleteGroupMsgOpenIndicatorId(null);
    }
  };
  const handleStarUnstarMsg = (timetoken, isalreadyStared) => {
    const reqBoby = {
      pn_id: selectedGroup?.pnId,
      timetoken: timetoken,
    };
    dispatch(
      handleStarMessage(
        reqBoby,
        selectedGroup?.pnId,
        selectedTopic,
        messageList,
        isThreadScreen
      )
    ).then((res) => {
      if (res?.status) {
        if (localStarMsgData?.includes(reqBoby?.timetoken)) {
          const updatedData = localStarMsgData?.filter(
            (item) => item !== reqBoby?.timetoken
          );
          setLocalStarMsgData(updatedData);
        } else if (
          !isalreadyStared?.includes(currentUserData?.id)
        ) {
          setLocalStarMsgData([...localStarMsgData, reqBoby?.timetoken]);
        }

        setMoreMenu(null);
        dispatch(handleGetStarMessages(selectedGroup?.pnId));
        //reqBobydispatch(handleFetchMessages({ groupId: selectedGroup?.id }));
      }
    });
  };
  const handleAiBtnCLick = () => {
    if (selectedGroup) {
      dispatch(handleShowAIScreen(true));
    }
  };
  // const handleRemoveStarScreen = () => {
  //   dispatch(handleStarMsgScreen(!showStarMessage));
  //   dispatch(handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id));
  //   dispatch(handleScrollToBottom(true));
  // };

  const scrollToRepliedMessage = (messageId) => {
    setHighlightedMessageId(messageId);
    setTimeout(() => {
      setHighlightedMessageId(null);
    }, 2000);

    const repliedMessageElement = document.getElementById(
      `replied-message-${messageId}`
    );
    if (repliedMessageElement) {
      repliedMessageElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Runs synchronously after every render that changes messageList, before the
  // browser has a chance to paint. If we saved scrollHeight before a prepend
  // dispatch, we add the exact delta to scrollTop here so the viewport stays
  // locked on the same content with zero visual jump.
  useLayoutEffect(() => {
    const container = chatContainerRef.current;
    if (!container || prevScrollHeightRef.current === null) return;
    const delta = container.scrollHeight - prevScrollHeightRef.current;
    if (delta > 0) {
      // Use behavior:'instant' to bypass the container's scroll-behavior:smooth,
      // otherwise the browser animates the correction and the user sees a jump.
      container.scrollTo({ top: container.scrollTop + delta, behavior: "instant" });
      prevScrollHeightRef.current = null;
    }
    // If delta === 0, keep the snapshot — the prepend hasn't been committed yet.
  }, [messageList]);

  ////
  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  };
  const handleScroll = debounce(() => {
    const activeChannel = selectedGroup?.pnId;

    if (chatContainerRef?.current) {
      const { scrollTop } = chatContainerRef.current;
      let shouldConsiderScrollTop = false;

      if (messageList?.length > 0) {
        shouldConsiderScrollTop = messageList[0]?.pnId === activeChannel;
      }

      const isNearTop =
        scrollTop <= 201 && shouldConsiderScrollTop && messageList?.length > 20;

      // Only update state if necessary
      if (isScrollingToTop !== isNearTop) {
        setIsScrollingToTop(isNearTop);
      }

      // Show group name when scrolling down (scrollTop > 0), hide when at top
      const shouldShowGroupName = scrollTop > 0;
      if (isShowGroupName !== shouldShowGroupName) {
        setIsShowGroupName(shouldShowGroupName);
      }
    }
  }, 50);

  const handleShowUserProfile = (userToFindData) => {
    let data = findUser(groupmemberdetails, userToFindData);

    if (!data) {
      setProfileViewModal(true);
      dispatch(getUserProfileDetails(userToFindData)).then((res) => {
        data = res;
        setProfileData(data, setProfileViewData, setProfileViewModal);
      });
    } else {
      setProfileData(data, setProfileViewData, setProfileViewModal);
    }
  };

  // Reset all load guards whenever the selected group/channel or topic/subtopic filter changes
  useEffect(() => {
    isLoadingOldMsgRef.current = false;
    hasReachedEndRef.current = false;
    prevScrollHeightRef.current = null;
  }, [selectedGroup?.pnId, selectedTopic?.id, selectedSubtopic?.id]);

  useEffect(() => {
    if (!isScrollingToTop || isLoadingOldMsgRef.current || hasReachedEndRef.current) return;
    isLoadingOldMsgRef.current = true;
    dispatch(handleScrollToBottom(false));

    const container = chatContainerRef.current;
    if (!container) {
      isLoadingOldMsgRef.current = false;
      setIsScrollingToTop(false);
      return;
    }

    const oldMsgPayload = selectedSubtopic?.id
      ? { topicId: selectedTopic?.id, subtopicId: selectedSubtopic?.id }
      : selectedTopic?.id ? { topicId: selectedTopic?.id } : {};

    // Resets the in-flight guard and allows the scroll handler to re-evaluate.
    // setIsScrollingToTop(false) is critical: the useEffect only fires when the
    // value CHANGES, so resetting it lets a second scroll-up re-trigger a load.
    const finishLoad = () => {
      isLoadingOldMsgRef.current = false;
      setIsScrollingToTop(false);
    };

    if (!isThreadScreen && !showStarMessage) {
      // Snapshot scrollHeight before the prepend so useLayoutEffect can correct
      // scrollTop in the same frame — the user sees no jump at all.
      prevScrollHeightRef.current = container.scrollHeight;

      // Oldest message currently loaded — the cursor for both the local-DB
      // lookup and, if the DB turns out to be exhausted, the server request.
      const oldestLoadedTimetoken = messageList[0]?.timetoken;

      dispatch(
        handleFetchOldMessage(
          selectedGroup?.pnId,
          selectedTopic?.id,
          oldestLoadedTimetoken,
          selectedSubtopic?.id || ""
        )
      ).then((res) => {
        if (res?.length > 0) {
          // useLayoutEffect handles scroll restoration; just reset flags.
          finishLoad();
          // Background-prefetch the next older batch so the following scroll-up
          // is instant. `res` is ascending by timetoken, so res[0] is the new
          // oldest loaded message — the correct cursor for the next batch.
          dispatch(fetchOldMessageFromApi(selectedGroup, oldMsgPayload, true, res[0]?.timetoken));
        } else {
          // DB exhausted — nothing was prepended; refresh the snapshot.
          prevScrollHeightRef.current = container.scrollHeight;

          dispatch(fetchOldMessageFromApi(selectedGroup, oldMsgPayload, false, oldestLoadedTimetoken)).then(
            (newMsgs) => {
              if (newMsgs?.length > 0) {
                // useLayoutEffect handles scroll restoration.
                finishLoad();
                // newMsgs is ascending by timetoken, so [0] is the new oldest.
                dispatch(fetchOldMessageFromApi(selectedGroup, oldMsgPayload, true, newMsgs[0]?.timetoken));
              } else if (newMsgs === null) {
                // Network error — clear the snapshot and allow a future retry.
                prevScrollHeightRef.current = null;
                finishLoad();
              } else {
                // Empty array = server confirmed no more history.
                prevScrollHeightRef.current = null;
                hasReachedEndRef.current = true;
                finishLoad();
              }
            }
          );
        }
      });
    } else if (showStarMessage) {
      // Star messages use a different Redux slice (not messageList), so
      // useLayoutEffect won't fire — restore scroll the traditional way.
      const currentScrollPosition = container.scrollHeight - container.scrollTop;
      const page = Math.floor(starMsgData?.messages?.length / 50) + 1;
      dispatch(handleGetStarMessages(selectedGroup?.pnId, page)).then(() => {
        setTimeout(() => {
          container.scrollTo({ top: container.scrollHeight - currentScrollPosition, behavior: "instant" });
          finishLoad();
        }, 0);
      });
    } else {
      isLoadingOldMsgRef.current = false;
      setIsScrollingToTop(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScrollingToTop]);

  /////

  useEffect(() => {
    if (isScrollToBottom) {
      scrollToBottom();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageList, tempMsgList]);

  useEffect(() => {
    if (selectedGroup?.isGroup) {
      dispatch(handleGetStarMessages(selectedGroup?.pnId));
    }
  }, [dispatch, selectedGroup]);
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      height={"100%"}
      overflow={"hidden"}
    >
      <Box display={"flex"} marginTop="8px" flexShrink={0}>
        <ProfileDetailModal
          setProfileViewModal={setProfileViewModal}
          isProfileViewOpen={isProfileViewOpen}
          profileViewData={profileViewData}
          setProfileViewData={setProfileViewData}
        />
      </Box>


      {/* 
      {isShowGroupName && (
        <Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            sx={
              {
                //background: "#E3E3E3",
              }
            }
          >
            <Box
              sx={{
                border: "2px solid transparent",
                borderRadius: "2px",
                background: "#E1E1E1",
                width: "230px",
                height: "30px",
                px: 2,
                py: 0.5,
                position: "relative",
                minWidth: "120px", // adjust as needed
                textAlign: "center",
              }}
            >
              <Typography
                fontSize={fontSizeSchemes.font14}
                fontWeight={400}
                color="#1A2B3C"
                title={`${selectedGroup?.name}${
                  selectedGroup?.isBuyerSellerGroup
                    ? " - Buyer/Seller Group"
                    : ""
                }`}
              >
                {`${selectedGroup?.name}${
                  selectedGroup?.isBuyerSellerGroup
                    ? " - Buyer/Seller Group"
                    : ""
                }`}
              </Typography>
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: -6,
                  height: "4px",
                  //background: "#2C86FF",
                  //borderRadius: "2px",
                  mx: "auto",
                  width: "100%",
                }}
              />
            </Box>
          </Box>
        </Box>
      )} */}

      <Box
        maxWidth={"100%"}
        sx={{
          position: "relative",
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          scrollBehavior: "smooth",
          paddingBottom: "8px",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "3px",
          },
        }}
        ref={chatContainerRef}
        onScroll={handleScroll}
      >
        {(selectedGroup?.isGroup || !selectedGroup?.isGroup) &&
          messageList?.length === 0 &&
          tempMsgList?.length === 0 &&
          !showStarMessage && (
            <EmptyMsg
              content={
                selectedGroup?.isGroup ? appContent?.KEY207 : appContent?.KEY208
              }
            />
          )}

        {showStarMessage && selectedGroup?.isGroup ? (
          <Box>
            {starMsgData?.messages?.length > 0 &&
              starMsgData?.messages?.map((item) => (
                <StarMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  key={item?.timetoken + "starmessageGrpList"}
                  item={item}
                  isMoreMenuOpen={isMoreMenuOpen}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  isDeleteGroupMsgOpenIndicatorId={
                    isDeleteGroupMsgOpenIndicatorId
                  }
                  handleClickTaskUpdate={handleClickTaskUpdate}
                  isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                  handleReadStatusDrawer={handleReadStatusDrawer}
                  setisTopicOpen={setisTopicOpen}
                  setMoveTopicMsgId={setMoveTopicMsgId}
                  setMoveTopicTriggered={setMoveTopicTriggered}
                  setDeleteGroupMsgOpenIndicatorId={
                    setDeleteGroupMsgOpenIndicatorId
                  }
                  setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                  handlegetThreadMessages={handlegetThreadMessages}
                  setMoreMenu={setMoreMenu}
                  menuRef={menuRef}
                  isThreadScreen={isThreadScreen}
                  selectedGroup={selectedGroup}
                  toggleItemMenu={toggleItemMenu}
                  startTaskOpen={startTaskOpen}
                  setStartTaskOpen={setStartTaskOpen}
                  handleStartTask={handleStartTask}
                  handleStarUnstarMsg={handleStarUnstarMsg}
                  handleDeleteGrpMsg={handleDeleteGrpMsg}
                  setHighlightedMessageId={setHighlightedMessageId}
                  bgcolor={
                    highlightedMessageId === item?.temp_timetoken
                      ? "#F9F8F8"
                      : "transparent"
                  }
                  scrollToRepliedMessage={scrollToRepliedMessage}
                  highlightText={highlightText}
                  searchInputValue={searchInputValue}
                  onPreviewFile={onPreviewFile}
                />
              ))}
          </Box>
        ) : (
          <>
            {selectedGroup?.isGroup &&
              messageList?.length > 0 &&
              messageList?.map((item, i) => (
                <Box key={"GroupMessageViewParent" + i}>
                  {item?.participants?.includes(
                    currentUserData?.id
                  ) && (
                      <GroupMessageView
                        item={item}
                        groupRecipientDetails={groupRecipientDetails}
                        key={item?.temp_timetoken + "GroupmessageView" + i}
                        isMoreMenuOpen={isMoreMenuOpen}
                        handleShowUserProfile={handleShowUserProfile}
                        threeDotRef={threeDotRef}
                        currentUserData={currentUserData}
                        isDeleteGroupMsgOpenIndicatorId={
                          isDeleteGroupMsgOpenIndicatorId
                        }
                        handleClickTaskUpdate={handleClickTaskUpdate}
                        isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                        handleReadStatusDrawer={handleReadStatusDrawer}
                        setisTopicOpen={setisTopicOpen}
                        setMoveTopicMsgId={setMoveTopicMsgId}
                        setMoveTopicTriggered={setMoveTopicTriggered}
                        setDeleteGroupMsgOpenIndicatorId={
                          setDeleteGroupMsgOpenIndicatorId
                        }
                        setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                        progress={progress}
                        handlegetThreadMessages={handlegetThreadMessages}
                        setMoreMenu={setMoreMenu}
                        menuRef={menuRef}
                        isThreadScreen={isThreadScreen}
                        selectedGroup={selectedGroup}
                        toggleItemMenu={toggleItemMenu}
                        startTaskOpen={startTaskOpen}
                        setStartTaskOpen={setStartTaskOpen}
                        handleStartTask={handleStartTask}
                        handleStarUnstarMsg={handleStarUnstarMsg}
                        handleDeleteGrpMsg={handleDeleteGrpMsg}
                        setDeleteGrpMsgType={setDeleteGrpMsgType}
                        highlightText={highlightText}
                        searchInputValue={searchInputValue}
                        localStarMsgData={localStarMsgData}
                        bgcolor={
                          highlightedMessageId === item?.temp_timetoken
                            ? "#F9F8F8"
                            : "transparent"
                        }
                        scrollToRepliedMessage={scrollToRepliedMessage}
                        dispatch={dispatch}
                        onPreviewFile={onPreviewFile}
                      />
                    )}
                </Box>
              ))}
            {tempMsgList?.length > 0 &&
              selectedGroup?.isGroup &&
              tempMsgList?.map((item, i) => (
                <TempMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  selectedGroup={selectedGroup}
                  item={item}
                  key={item?.temp_timetoken + "tempMsg"}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  handleSendTempMsg={handleSendTempMsg}
                  progress={progress}
                />
              ))}
          </>
        )}

        <>{/* This is for Render DM */}</>
        {!selectedGroup?.isGroup && (
          <>
            {messageList?.length > 0 &&
              messageList?.map((item) => (
                <DirectMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  isDMMoreMenuOpen={isDMMoreMenuOpen}
                  setDMMoreMenuOpen={setDMMoreMenuOpen}
                  isDeleteGroupMsgOpenIndicatorId={
                    isDeleteGroupMsgOpenIndicatorId
                  }
                  isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                  setDeleteGrpMsgType={setDeleteGrpMsgType}
                  setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                  setDeleteGroupMsgOpenIndicatorId={
                    setDeleteGroupMsgOpenIndicatorId
                  }
                  handleDeleteGrpMsg={handleDeleteGrpMsg}
                  item={item}
                  key={item?.temp_timetoken + "Directmessage"}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  handleSendTempMsg={handleSendTempMsg}
                  setReplyParentMsg={setReplyParentMsg}
                  bgcolor={
                    highlightedMessageId === item?.temp_timetoken
                      ? "#F9F8F8"
                      : "transparent"
                  }
                  scrollToRepliedMessage={scrollToRepliedMessage}
                  onPreviewFile={onPreviewFile}
                />
              ))}
            {tempMsgList?.length > 0 &&
              tempMsgList?.map((item, i) => (
                <TempMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  selectedGroup={selectedGroup}
                  item={item}
                  key={item?.temp_timetoken + "DirecttempMsg"}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  handleSendTempMsg={handleSendTempMsg}
                  progress={progress}
                />
              ))}
          </>
        )}
      </Box>
      {/* Floating PersonFloat Button */}
      {selectedGroup?.isGroup && isPrivateChatOn ? (
        <LableToolTip title={appContent?.KEY254}>
          <Box
            onClick={handleAiBtnCLick}
            sx={FloatBtnStyle}
          >
            <img
              src={AiFloat}
              alt="Person Float"
              style={FloatImgStyle}
            />
          </Box>
        </LableToolTip>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default MessageList;
